export const SET_USER_PRODUCT_DETAIL_FIELDS = "SET_USER_PRODUCT_DETAIL_FIELDS";
export const SET_USER_PRODUCT_DETAIL = "SET_USER_PRODUCT_DETAIL";
export const SET_PRODUCTS_USER = "SET_PRODUCTS_USER";
export const SET_DIALOG_PRODUCT_USER_ACTIVE = "SET_DIALOG_PRODUCT_USER_ACTIVE";
